import useTranslator from "../../hooks/useTranslator";
import { useNavigate, useParams } from "react-router-dom";
import { haveValue } from "../../helper/common";
import { useContext } from "react";
import AuthContext from "../../context/auth/AuthContext";
import { Icon, Modal, OptionCard } from "../design";
import "./LinkedTenantsProperties.css";

const LinkedTenantsProperties = ({
  propertiesData,
  showPropertiesPopup,
  setShowPropertiesPopup,
}) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const { workspaceId } = useParams();

  return (
    <Modal
      open={Boolean(showPropertiesPopup)}
      onClose={() => setShowPropertiesPopup(false)}
      title={_t("tenantLinkedProperties")}
      closeLabel={_t("close")}
      align="start"
    >
      <ul className="linked-properties__list">
        {propertiesData?.map((property) => {
          const propertyName = `${property?.street} - ${
            Number.isNaN(parseInt(property?.street_number, 10))
              ? "N/A"
              : String(parseInt(property?.street_number, 10))
          }, ${property?.floor_number}${
            property?.flat_number ? ` - ${property?.flat_number}` : ""
          }`;
          return (
            <li key={property?._id}>
              <OptionCard
                icon={<Icon name="building" />}
                title={propertyName}
                onClick={() =>
                  navigate(
                    user?.role === "landlord" && haveValue(workspaceId)
                      ? `/${workspaceId}/home?propertyId=${property?._id}&propName=${propertyName}`
                      : `/home?propertyId=${property?._id}&propName=${propertyName}`
                  )
                }
              />
            </li>
          );
        })}
      </ul>
    </Modal>
  );
};

export default LinkedTenantsProperties;
